export default {
  contacts: [],
  pagination: {},
  contact: {}
}
